import React from 'react'
import {Marketplace} from 'js/types/marketplace'
import MarketplaceHeader from '../Marketplace/MarketplaceHeader'

interface Props {
  marketplace: Marketplace
}

const RegisterHeader = ({marketplace}: Props): JSX.Element => {
  switch (marketplace) {
    case 'aws':
      return (
        <MarketplaceHeader
          header="AWS Verification"
          subtitle="Oops, something went wrong with the Amazon subscription for InfluxDB Cloud Usage-Based Plan"
        />
      )
    case 'azure':
      return (
        <MarketplaceHeader
          header="Azure Registration"
          subtitle="Oops, something went wrong when configuring your account for the InfluxDB Cloud Usage-Based Plan"
        />
      )
    case 'gcm':
      return (
        <MarketplaceHeader
          header="Google Cloud Verification"
          subtitle="Oops, something went wrong with the Google Cloud subscription for InfluxDB Cloud Usage-Based Plan"
        />
      )
  }
}

export default RegisterHeader
